import styled from "styled-components";

import { LoginFormProps  } from "./props";

export const LoginContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
`;

export const LoginFormSection = styled.div`
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const LoginInputText = styled.input<LoginFormProps>`
  border: ${(props) =>
    props.hasError ? "1px solid red !important" : "1.5px solid var(--line);"};
  padding: 12px 8px;
  min-width: 300px;
  text-align: center;
  letter-spacing: 1px;
  border-radius: 8px;
  outline: none;
  color: var(--text);
  background: var(--surface);

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const LoginIcon = styled.img`
  height: 24px;
  width: 24px;
  margin-bottom: 2px;
  filter: var(--illustration-filter);
`;

export const LoginButton = styled.button`
  width: 100%;
  min-width: 318px;
  border: 1px solid var(--text);
  border-radius: 8px;
  padding: 12px 16px;
  background: var(--text);
  color: var(--page);
  cursor: pointer;
  font: inherit;

  &:disabled {
    cursor: wait;
    opacity: 0.6;
  }
`;

export const LoginMessage = styled.p`
  max-width: 318px;
  margin: 2px 0 0;
  color: #b3261e;
  font-size: 13px;
  line-height: 1.45;
  text-align: center;
`;
